import React, { useEffect, useState } from "react";
import { Form, Row, Col, Button, Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import Axios from "axios";
import { isBrowser } from "react-device-detect";

//STYLES
import * as YourDetailsStyles from "../styles/yourDetails";

function YourDetails(props) {
    const user = useSelector((state) => state.user);

    const [details, setDetails] = useState({
        name: "",
        email: "",
        addressLine1: "",
        addressLine2: "",
        town: "",
        postcode: "",
        telephone: ""
    });

    const modalDefaultValues = {
        open: false,
        header: "",
        message: ""
    };

    const [modal, setModal] = useState(modalDefaultValues);

    function handleModalClose() {
        setModal(modalDefaultValues);
    }

    useEffect(() => {
        props.navigation("details");
        loadDetails();
    }, []);

    function loadDetails() {
        const data = { userID: user.id };
        Axios.post("/pods/3dPrintingShop/frontEnd/profile/fetchUserDetails", data)
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    setDetails((prevState) => {
                        return {
                            ...prevState,
                            name: data.details.fullname,
                            email: data.details.email,
                            addressLine1: data.details.addressLine1,
                            addressLine2: data.details.addressLine2,
                            town: data.details.town,
                            postcode: data.details.postcode,
                            telephone: data.details.tel
                        };
                    });
                }
            })
            .catch((err) => console.log(err));
    }

    function handleOnChange(event) {
        const { name, value } = event.target;

        setDetails((prevState) => {
            return { ...prevState, [name]: value };
        });
    }

    function handleOnUpdate() {
        const data = { userID: user.id, details: details };
        Axios.post("/pods/3dPrintingShop/frontEnd/profile/updateUserDetails", data)
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    setModal({ header: "User's Details", message: "Your details has been updated", open: true });
                }
            })
            .catch((err) => console.log(err));
    }

    const browserDisplay = (
        <div>
            <Row>
                <Col>
                    <Form.Group>
                        <Form.Label>Name:</Form.Label>
                        <Form.Control type="text" name="name" value={details.name} onChange={handleOnChange} />
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group>
                        <Form.Label>Email:</Form.Label>
                        <Form.Control type="text" name="email" value={details.email} onChange={handleOnChange} />
                    </Form.Group>
                    <br />
                    <p style={YourDetailsStyles.emailNote}>If you change your email, it will change the email you use to log in!</p>
                </Col>
            </Row>
            <br />
            <Row>
                <Col>
                    <Form.Group>
                        <Form.Label>Address Line 1:</Form.Label>
                        <Form.Control type="text" name="addressLine1" value={details.addressLine1} onChange={handleOnChange} />
                    </Form.Group>
                    <br />
                    <Form.Group>
                        <Form.Label>Town:</Form.Label>
                        <Form.Control type="text" name="town" value={details.town} onChange={handleOnChange} />
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group>
                        <Form.Label>Address Line 2:</Form.Label>
                        <Form.Control type="text" name="addressLine2" value={details.addressLine2} onChange={handleOnChange} />
                    </Form.Group>
                    <br />
                    <Form.Group>
                        <Form.Label>Postcode:</Form.Label>
                        <Form.Control type="text" name="postcode" value={details.postcode} onChange={handleOnChange} />
                    </Form.Group>
                </Col>
            </Row>
            <br />
            <Row>
                <Col>
                    <Form.Group>
                        <Form.Label>Telephone:</Form.Label>
                        <Form.Control type="text" name="telephone" value={details.telephone} onChange={handleOnChange} />
                    </Form.Group>
                </Col>
                <Col style={YourDetailsStyles.columnRight}>
                    <Button onClick={handleOnUpdate}>Update Details</Button>
                </Col>
            </Row>
        </div>
    );

    const mobileDisplay = (
        <div style={YourDetailsStyles.mobile_leftMargin}>
            <div>
                <Form.Group>
                    <Form.Label>Name:</Form.Label>
                    <Form.Control type="text" name="name" value={details.name} onChange={handleOnChange} />
                </Form.Group>
            </div>
            <br />
            <div>
                <Form.Group>
                    <Form.Label>Email:</Form.Label>
                    <Form.Control type="text" name="email" value={details.email} onChange={handleOnChange} />
                </Form.Group>
                <br />
                <p style={YourDetailsStyles.emailNote}>If you change your email, it will change the email you use to log in!</p>
            </div>
            <br />
            <div>
                <Form.Group>
                    <Form.Label>Address Line 1:</Form.Label>
                    <Form.Control type="text" name="addressLine1" value={details.addressLine1} onChange={handleOnChange} />
                </Form.Group>
            </div>
            <br />
            <div>
                <Form.Group>
                    <Form.Label>Address Line 2:</Form.Label>
                    <Form.Control type="text" name="addressLine2" value={details.addressLine2} onChange={handleOnChange} />
                </Form.Group>
            </div>
            <br />
            <div>
                <Form.Group>
                    <Form.Label>Town:</Form.Label>
                    <Form.Control type="text" name="town" value={details.town} onChange={handleOnChange} />
                </Form.Group>
            </div>
            <br />
            <div>
                <Form.Group>
                    <Form.Label>Postcode:</Form.Label>
                    <Form.Control type="text" name="postcode" value={details.postcode} onChange={handleOnChange} />
                </Form.Group>
            </div>
            <br />
            <div>
                <Form.Group>
                    <Form.Label>Telephone:</Form.Label>
                    <Form.Control type="text" name="telephone" value={details.telephone} onChange={handleOnChange} />
                </Form.Group>
            </div>
            <br />
            <div>
                <Button style={YourDetailsStyles.mobile_updateButton} onClick={handleOnUpdate}>
                    Update Details
                </Button>
            </div>
        </div>
    );

    return (
        <div style={YourDetailsStyles.body}>
            {isBrowser ? browserDisplay : mobileDisplay}
            <Modal show={modal.open} onHide={handleModalClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{modal.header}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{modal.message}</Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleModalClose}>Close</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default YourDetails;
